import SignUpOnboarding from "./SignUpOnboarding/SignUpOnboarding";
import SignUp from "views/SignInFlow/SignUp/SignUp";
import "views/SignInFlow/SignInFlow.css"
import {useAppSelector} from "store/hooks";
import SignUpThankYou from "./SignUpThankYou/SignUpThankYou";
import SignUpCreateAccount from "./SignUpCreateAccount/SignUpCreateAccount";
import SignIn from "views/SignInFlow/SignIn/SignIn";
import SignInForgotPassword from "views/SignInFlow/SignInForgotPassword/SignInForgotPassword";

function SignInFlow() {
  const signUpScreen = useAppSelector(state => state.signUpScreen.screen);
  const userType: UserType = useAppSelector(state => state.userType);

  // render screen based on the string given as a parameter
  const renderScreen = (signUpScreen: string) => {
    switch (signUpScreen) {
      case 'SignUpScreen':
        // if there's a user type cached in redux, then navigate to sign in screen
        return userType.brand ? <SignUpCreateAccount/> : <SignUp/>
      case 'SignUpThankYouScreen':
        return <SignUpThankYou userType={userType}/>
      case 'SignUpCreateAccountScreen':
        return <SignUpCreateAccount/>
      case 'SignInScreen':
        return <SignIn/>
      case 'SignInForgotPasswordScreen':
        return <SignInForgotPassword/>
      default:
        return <SignUp/>
    }
  }

  return (
    <div className={'sign-up'}>
      <SignUpOnboarding/>
      {renderScreen(signUpScreen)}
    </div>
  )
}

export default SignInFlow;
